import { Component } from '@angular/core';

@Component({
  selector: 'app-cp-01-40-07-06',
  standalone: true,
  imports: [],
  templateUrl: './cp-01-40-07-06.component.html',
  styleUrl: './cp-01-40-07-06.component.scss'
})
export class Cp01400706Component {

}
